import React, { useContext } from "react";
import SidebarView from "./Sidebar-view";
import { LoggedInUserContext } from "contexts/LoggedInUser";

/**
 * Control the creation of the Sidebar component
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
const SidebarContainer = ({ collapsed, onToggle }) => {
  const { loggedInUserProfile } = useContext(LoggedInUserContext);
  return (
    <SidebarView
      collapsed={collapsed}
      onToggle={onToggle}
      loggedInUserProfile={loggedInUserProfile}
    />
  );
};

export default SidebarContainer;
